(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.rollInText = {
    attach: (context) => {
      var rollInText = $('.roll-in-text:not(.ck-content .roll-in-text)', context);
      if (!rollInText.length) {
        return;
      }

      // Do not do any of this if person has prefers-reduced-motion set.
      var mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
      if (!mediaQuery || mediaQuery.matches) {
        return;
      }

      // Grab the first relevant item; shouldn't be more but if there are ignore them.
      // Note the observer needs a plain JS element, not a jQuery object.
      var textWrapper = document.getElementsByClassName('roll-in-text')[0];
      var fullHeight = textWrapper.offsetHeight;
      $(textWrapper).css('height', fullHeight);
      var textElement = textWrapper.children[0];
      var origContent = textElement.textContent.split('');
      textElement.textContent = '';
      var newText = '';
      
      // Start putting content back when the element is 20% in view.
      var visibilityTrigger = function(entries, observer) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            observer.unobserve(textWrapper);
            var printInterval = window.setInterval(function(){
              newText += origContent.shift();
              textElement.textContent = newText;
              if (!origContent.length) {window.clearInterval(printInterval);}
            }, 40);
          }
        });
      };
      var observerOptions = { threshold: 0.2 };
      var observer = new IntersectionObserver(visibilityTrigger, observerOptions);
      observer.observe(textWrapper);
    }
  };

})(jQuery, Drupal);